// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"681":"b9517bd3d22f352e","888":"eeb35c60be1b737a"}[chunkId] + ".css";
};